import { Directive, Inject } from '@angular/core';

@Directive({
  selector: `nimbus-auth`
})
export class NimbusAuthComponent {
  constructor(
    @Inject('isBrowser') isBrowser: boolean
  ) {
    if (isBrowser) {
      require('nimbus-auth/src/auth.js');
    }
  }
}
